// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

class paymentAPI extends MainAPI {
	/**
	 * @return No content
	 * @params orderId
	 * @params body - tracking number, tracking link
	 * */
	async putPaymentStatus(orderId) {
		return API.put(`${ENDPOINTS.PUT_PAYMENT}/${orderId}/update-status`)
	}

	/**
	 * @return {object} payment details
	 * @params details { token, referenceNumber }
	 * */
	async processPendingPayment(details) {
		return API.put(`${ENDPOINTS.PUT_PROCESS_PAYMENT}/process-payment`, details)
	}

	/**
	 * @return No content
	 * @params dogPurchaseId, dogPurchasePaymentId
	 * */
	async dogPurchaseManualProcessPendingPayment(dogPurchaseId, dogPurchasePaymentId, status) {
		return API.put(
			`${ENDPOINTS.PUT_PROCESS_LATITUDE_INTEREST_FREE}/dog-purchase-payment/${dogPurchaseId}/${dogPurchasePaymentId}/${status}`
		);
	}

	/**
	 * @return No content
	 * @params puppySellId, puppySellPurchaseId
	 * */
	async puppyPurchaseManualProcessPendingPayment(puppySellId, puppySellPurchaseId, status) {
		return API.put(
			`${ENDPOINTS.PUT_PROCESS_LATITUDE_INTEREST_FREE}/puppy-purchase-payment/${puppySellId}/${puppySellPurchaseId}/${status}`
		);
	}
}

export default new paymentAPI()
